<dashboard-dialog-frame [header]="'Vega charts'" [dialogRef]='dialogRef' [actions]="actions">

	<div class='view-charts-dialog-content'>
		<button class="btn" (click)="addChart()">+</button>
	</div>

</dashboard-dialog-frame>